/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card options instance
 *
 * @module enervee_utils.product_card
 */
function productCardBaseOptions() {
    return {
        restrict: 'E',
        // this is needed to fix spacing issues
        replace: true,
        scope: {
            product: '='
        },
        controller: productCardOptionsController,
        template: require('./optionsView.html')
    };
}
productCardOptionsController.$inject = ['$scope', '$state', 'AnalyticsService'];
function productCardOptionsController($scope, $state, AnalyticsService) {
    $scope.moreOptions = false;

    var isSiblingProductsEnabled = $scope.product.category.sibling_products_toggle;

    if (isSiblingProductsEnabled && $scope.product.varying_features_json && $scope.product.varying_features_json.length > 0) {
        $scope.moreOptions = true;
    }

    /**
     * Tracks more options clicks and redirects into the child product's details page
     */
    $scope.trackProductSelectedAndGoToProduct = function (event) {

        var moreOptionsDetails = {
            price: $scope.product.lowest_priced_child.price,
            url: $scope.product.lowest_priced_child.product_short_link
        };

        AnalyticsService.reportEvent('More Options', moreOptionsDetails, $scope.product);

        $state.go(
            'product',
            {
                category_code: $scope.product.category.category_code,
                product_info: $scope.product.lowest_priced_child.product_short_link
            },
            {
                reload: true
            }
        );
    };

}

module.exports = productCardBaseOptions;
